module.exports = __webpack_public_path__ + "img/smart-assistant.ee3a458a.png";